module.exports = __webpack_public_path__ + "static/img/pokdenggame_th.fb2c463.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sa/pokdenggame_th.png
// module id = Yzfl
// module chunks = 1